export default "__VITE_ASSET__CbLqL7Fs__"